var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "confirm-main"
  }, [_c('div', {
    staticClass: "confirm-title"
  }, [_c('h1', {
    staticClass: "confirm-text"
  }, [_vm._v(_vm._s(_vm.title || '确认'))]), _vm._v(" "), _c('i', {
    staticClass: "confirm-cancel",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('p', {
    staticClass: "confirm-content"
  }, [_vm._v(_vm._s(_vm.content || '是否确定该选择'))]), _vm._v(" "), _c('div', {
    staticClass: "confirm-footer"
  }, [_c('button', {
    staticClass: "confirm-footer-success",
    on: {
      "click": _vm.okFn
    }
  }, [_vm._v(_vm._s(_vm.ok || '确定'))]), _vm._v(" "), _c('button', {
    staticClass: "confirm-footer-default",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v(_vm._s(_vm.cancel || '取消'))])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc5f921","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/vuejs-modal/lib/confirm.vue
// module id = +Xhc
// module chunks = 1